import React, { FC } from 'react'

import { Navigation } from '@ucheba/ui/components/Navigation/desktop'
import { useDivisionsNavigation } from '../bll/useDivisionsNavigation'

const DivisionsNavigation: FC = () => {
  const { items, activeIndex, onClick } = useDivisionsNavigation()

  if (!items.length) return <></>

  return <Navigation items={items} activeIndex={activeIndex} onClick={onClick} />
}

export default DivisionsNavigation
